import { TableConfig } from '@shared/interfaces/table/table-config';
import { MeteringPointQueryResultDto } from '@app/api/dmc';
import {
  addressPartial,
  meteringPointIdentificationPartial,
  meterNumberPartial,
  meterQuadrantPartial
} from '@shared/columns/meteringpoint.columns';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { physicalStatusPartial } from '@shared/partials/physicalstatus.partial';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { hasBalanceSupplierPartial } from '@shared/partials/has-balance-supplier.partial';
import { isChildPartial } from '@shared/partials/isChildPartial';
import { existsInDatahub } from '@shared/partials/existsindatahub.partial';

export const meteringPointDirectRelationTable: TableConfig<MeteringPointQueryResultDto> = {
  id: 'meteringpoint-relation-list',
  reorder: true,
  saveChanges: true,
  pageSize: 10,
  columns: [
    meterQuadrantPartial,
    meteringPointIdentificationPartial,
    addressPartial,
    settlementmethodPartial,
    meteringPointTypePartial,
    physicalStatusPartial,
    meterNumberPartial,
    datahubPartial,
    hasBalanceSupplierPartial,
    isChildPartial,
    existsInDatahub,
  ]
}
